import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterList, beforeList } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function BeforeAfter() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-17" data-mp="3ogj8jjd1u8h1">
      <SectionHeading eyebrow="AVANT VS. APRÈS" title={<>Arrêtez d'improviser. <span className="text-gold" data-id="element-19" data-mp="3epydg5wl3m2v">Enseignez avec un système.</span></>} data-id="element-18" data-mp="3sh378rd9tk5a" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-20" data-mp="3envf8yla2mn2">
        <div className="rounded-2xl border border-line bg-ink p-5 sm:p-6" data-id="element-21" data-mp="3ji9a8zw12rr7">
          <h3 className="text-sm font-bold tracking-widest text-mute" data-id="element-22" data-mp="34stnrw3j58hb">SANS LE MAÎTRE DE LA GUITARE</h3>
          <ul className="mt-5 space-y-4" data-id="element-23" data-mp="39rws1eborao8">
            {beforeList.map(b => <li key={b} className="flex gap-3 text-mute" data-id="element-24" data-mp="2vqkgrg7gzx8o">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-25" data-mp="2vtgbywrxo7tf" />
                {b}
              </li>)}
          </ul>
        </div>
        <div className="rounded-2xl border-2 border-gold bg-ink p-5 sm:p-6" data-id="element-26" data-mp="x38yew2w6idl">
          <h3 className="text-sm font-bold tracking-widest text-gold" data-id="element-27" data-mp="t3qdi0b2m7ar">AVEC LE MAÎTRE DE LA GUITARE</h3>
          <ul className="mt-5 space-y-4" data-id="element-28" data-mp="172zs4vjmotcm">
            {afterList.map(a => <li key={a} className="flex gap-3 text-cream" data-id="element-29" data-mp="12354d0v5gjvs">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-30" data-mp="121k91910gwwv" />
                {a}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}